//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomPopup',
  props: {
    value: {},
    persistent: {
      type: Boolean,
      default: false
    },
    displayButton: {
      type: Boolean,
      default: true
    }
  },
}
